import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  constructor(private router:Router, private meta: Meta,private titleService: Title) {
    this.meta.updateTag({ name: 'description', content: "We are an Online Learning Company, reimaging the way Real Estate Professionals learn & upskill through a collection of industry-relevant certification programs" }); 
    titleService.setTitle("About Us | Edstate");
   }

  ngOnInit() {
  }

  navigateCourse(){
    this.router.navigateByUrl('/courses')
  }
  

}
